import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const REFUND_REQUESTS_REQUEST = 'REFUND_REQUESTS_REQUEST';
export const REFUND_REQUESTS_RESPONSE = 'REFUND_REQUESTS_RESPONSE';

export function submitRefundRequest(
  reasonForRefund,
  productEntitlementIdForRefund,
  bankName,
  accountHolder,
  accountNumber,
  history
) {
  fetch(`${API_URL}/refund-requests/current-user`, {
    method: 'POST',
    headers: commonHeaders(),
    body: JSON.stringify({
      reason: reasonForRefund,
      productEntitlementId: productEntitlementIdForRefund,
      bankName: bankName,
      accountHolder: accountHolder,
      accountNumber: accountNumber,
    }),
  })
    .then(commonErrorHandler)
    .then(() => {
      alert('환불/취소 요청이 접수됐습니다.');
      history.push('/my-pc-bang/usage-status/refund');
    })
    .catch(() => alert('환불/취소 요청에 실패했습니다.'));
}

function refundRequestsRequest() {
  return {
    type: REFUND_REQUESTS_REQUEST,
  };
}

function refundRequestsResponse(refundRequests) {
  return {
    type: REFUND_REQUESTS_RESPONSE,
    refundRequests,
  };
}

export function fetchRefundRequestsForCurrentUser() {
  return dispatch => {
    dispatch(refundRequestsRequest());
    fetch(`${API_URL}/refund-requests/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(refundableEntitlements => {
        dispatch(refundRequestsResponse(refundableEntitlements));
      });
  };
}
